import { Button, Card, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  buttonLabel,
  cardConfig,
  formConfig,
  paymentProcessType,
} from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';
import { useEffect, useState } from 'react';
import { updateConfigs } from '../../../../appRedux/actions';
import { useCustomModal } from '../../../../hooks/useCustomModal';

export const SettingPayementProcessModal = ({onSuccess}) => {
  const dispatch = useDispatch();
  const { configs } = useSelector((state) => state.configs);
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();
  const [isLoading, setIsLoading] = useState(false);
  const [configId, setConfigId] = useState();
  const [response, setResponse] = useState();

  useEffect(() => {
    setConfigId(configs?.id);
  }, [configs?.id]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);  
      if (onSuccess) {
        onSuccess();        
      }
    }
  }, [response, setShowModal, onSuccess]);

  useEffect(() => {
    if (configs && configs.paymentProcessType) {
      form.setFieldsValue({
        paymentProcessType: configs.paymentProcessType,
      });
    }
  }, [configs, form]);

  const onSubmit = async (values) => {
    setIsLoading(true);
    if (configId) {
      setResponse(await dispatch(updateConfigs(configId, values)));
    }
    setIsLoading(false);
  };

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form autoComplete="off" onFinish={onSubmit} form={form} {...formConfig}>
        <Form.Item name="paymentProcessType" label="Procesador de pago">
          <CustomSelect options={paymentProcessType}></CustomSelect>
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          className="btn-form"
          loading={isLoading}
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
